import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";

export const useRotatingMessages = (messages: string[], intervalMs: number = 30000) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, intervalMs);

    return () => clearInterval(interval);
  }, [messages.length, intervalMs]);

  return messages[currentIndex];
};

const messages = [
  "Brewing some digital coffee...",
  "Teaching robots to dance...",
  "Counting to infinity...",
  "Convincing pixels to cooperate...",
  "Herding cats in cyberspace...",
  "Spinning up the hamster wheels...",
  "Asking the internet nicely...",
  "Reticulating splines...",
  "Calibrating flux capacitor...",
  "Summoning the data wizards...",
];

export const LoadingToast = () => {

  const currentMessage = useRotatingMessages(messages, 30000);

  return (
    <div className="flex rounded-lg bg-white shadow-lg ring-1 ring-black/5 w-full md:max-w-[364px] min-w-[25vw] items-center p-4 gap-4 font-poppins tracking-wide">
      <Loader2 className="h-5 w-5 animate-spin text-primary" />
      <span className="text-sm font-medium animate-in fade-in duration-300">
        {currentMessage}
      </span>
    </div>
  );
};
